import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { RestriccionProductosExService } from '../restriccionproductoex.service';
import { FilterSearchingRestriccionProductosExViewModel, RestriccionProductosExItemResultsViewModel } from '../restriccionproductoex.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { FilterSearchingBaseViewModel, Tc } from '../../../../core/_infrastructure/types/common';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';

@Component({
    selector: 'app-restriccionproductoex-wrapper',
    templateUrl: './restriccionproductoex-wrapper.component.html',
})
export class RestriccionProductosExWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: RestriccionProductosExItemResultsViewModel | null;
    payload?: FilterSearchingRestriccionProductosExViewModel;
    edition = false;

    grupos: Tc[];
    formas: Tc[];
    listPais: Tc[];

    listPais$ = this.globalService.getAllPaises().subscribe(params => {
        this.listPais = params;
    });

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private globalService: GlobalService,
        private restriccionProductosExService: RestriccionProductosExService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getGrupos();
        this.recoverLastSearch();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.restriccionProductosExService.getLastSearch();
    }

    private getGrupos(): void {
        this.globalService.getGrupos().subscribe((grupos: Tc[]) => {
            this.grupos = grupos;
        });
    }

    /**
     * Respond to the action of searching on restricciion-filter.
     * It will send the filter to the backend and set the response.
     * @param payload FilterSearchingRestriccionProductosExViewModel
     * @return void
     */
    onSearch(payload: FilterSearchingRestriccionProductosExViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingRestriccionProductosExViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.restriccionProductosExService.getRestriccionesProductosEx(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingRestriccionProductosExViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.formas = [];
        this.result = null;
        this.restriccionProductosExService.clearLastSearch();
    }

    /**
     * Invoked when the user selects a group in the filter
     * @param grupoId number
     * @return void
     */
    onGroupSelected(grupoId: number): void {
        this.globalService.getFormasByGrupo(grupoId).subscribe((formas: Tc[]) => {
            this.formas = formas;
        });
    }

    /**
     * Redirigimos al formulario de creación de una nueva variedad
     * @return void
     */
    onAdd(): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/especies/restriccionproductosex/create']);
    }

    /**
     * Redirigimos al formulario de edición de la variedad.
     * @param item { idEspecie, idPaisDestino}
     * @return void
     */
    onEdit(item: any): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/especies/restriccionproductosex/edit', item.idEspecie, item.idPaisDestino]);
    }

    onDelete(item: any): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.restriccionProductosExService.delete(item.idEspecie, item.idPaisDestino).subscribe({
                    next: () => {
                        this.addSuccessMessage('Restricción eliminada correctamente');
                        this.recoverLastSearch();
                        this.onSearch(this.payload!);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onClone(item: any): void {
        this.router.navigate(['/mantenimiento/especies/restriccionproductosex/clone', item.idEspecie, item.idPaisDestino]);
    }
}
